import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Bug = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M6 9V13M6 9L3.25 8M6 9C6 8.44772 6.44772 8 7 8H17C17.5523 8 18 8.44772 18 9M6 13V15C6 18.3137 8.68629 21 12 21C15.3137 21 18 18.3137 18 15V13M6 13H3M18 13V9M18 13H21M18 9L20.75 8M6 17L3.25 18M18 17L20.75 18M12 13V20M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.75 7.2669H17.7C18.0904 7.2669 18.4258 7.50319 18.5719 7.84103L19.9878 7.3243C20.4809 7.14436 21.026 7.39963 21.2053 7.89446C21.3846 8.3893 21.1302 8.93631 20.6372 9.11625L18.65 9.84143V12.0338H20.55C21.0747 12.0338 21.5 12.4606 21.5 12.9872C21.5 13.5137 21.0747 13.9405 20.55 13.9405H18.65V14.8939C18.65 15.3036 18.6132 15.7046 18.5428 16.0938L20.6372 16.8581C21.1302 17.038 21.3846 17.585 21.2053 18.0799C21.026 18.5747 20.4809 18.83 19.9878 18.65L17.9378 17.9019C16.978 19.8063 15.1354 21.1863 12.95 21.5V12.9872C12.95 12.4606 12.5247 12.0338 12 12.0338C11.4753 12.0338 11.05 12.4606 11.05 12.9872V21.5C8.8646 21.1863 7.02196 19.8063 6.06219 17.9019L4.01216 18.65C3.51907 18.83 2.974 18.5747 2.7947 18.0799C2.61539 17.585 2.86976 17.038 3.36284 16.8581L5.45719 16.0938C5.38677 15.7046 5.35 15.3036 5.35 14.8939V13.9405H3.45C2.92533 13.9405 2.5 13.5137 2.5 12.9872C2.5 12.4606 2.92533 12.0338 3.45 12.0338H5.35V9.84143L3.36284 9.11625C2.86976 8.93631 2.61539 8.3893 2.7947 7.89446C2.974 7.39963 3.51907 7.14436 4.01216 7.3243L5.42813 7.84103C5.57425 7.50319 5.90963 7.2669 6.3 7.2669H7.25C7.25 4.63421 9.37665 2.5 12 2.5C14.6234 2.5 16.75 4.63421 16.75 7.2669ZM12 4.40676C10.426 4.40676 9.15 5.68729 9.15 7.2669H14.85C14.85 5.68729 13.574 4.40676 12 4.40676Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
